
import React from 'react';
import Hero from '../components/Hero';
import MarqueeBlocks from '../components/MarqueeBlocks';
import Services from '../components/Services';
import VIPSection from '../components/VIPSection';
import Reviews from '../components/Reviews';
import Locations from '../components/Locations';
import GalleryStrip from '../components/GalleryStrip';

const HomePage: React.FC = () => {
  return (
    <div className="animate-in fade-in duration-700 flex flex-col">
      {/* 1. Brand & CTA (Top) */}
      <Hero />
      
      {/* 2. Atmosphere & Service Info (Middle) */}
      <MarqueeBlocks />
      <Services />
      
      {/* 3. Social Proof & Availability */}
      <Reviews />
      <Locations />
      
      {/* 4. Cinematic Proof & Mastery (Bottom) */}
      <VIPSection />
      <GalleryStrip />
    </div>
  );
};

export default HomePage;
